import { useEffect, useState } from "react";

import "./AnimationScene.scss";

const STEPS = [
  "search",
  "layout",
  "layout-1",
  "site",
  "site-1",
  "article",
  "image",
  "final",
];

const STEP_DURATION = 3000;

export default function AnimationScene() {
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setStepIndex((s) => (s + 1) % STEPS.length);
    }, STEP_DURATION);

    return () => clearInterval(id);
  }, []);

  const step = STEPS[stepIndex];

  return (
    <div className="animation-scene">
      <div className={`animation-scene__frame frame-${step}`}>
        <div className="animation-scene__line-wrapper">
          <div className={`animation-scene__line line-${step}`} />
        </div>
        <div className={`animation-scene__article article-${step}`} />
      </div>

      <div className={`cursor cursor--${step}`} />
    </div>
  );
}
